import React from 'react'
import { useNavigate } from 'react-router-dom'

function ServiceCard({id, imgUrl, cardTitle, cardDesc}) {
    const navigate = useNavigate();

      const handleReadMore = () => {
    navigate(`/services/${id}`);
  };

  return (
    <div className='serviceCard'>
        <div className='card-image'>
           <img src={imgUrl} />
        </div>
        <div className='card-container'>
            <div className='card-title'>
                {cardTitle}
            </div>

            <div className='card-desc'>
                {cardDesc}
            </div>

            <div className='card-button'>
                <button className='card-btn' onClick={handleReadMore} >Read More</button>
            </div>
        </div>
    </div>
  )
}

export default ServiceCard